// src/shared/dashboard/shell/navLabels.ts
//
// The single source of localized nav labels (id → locale → text) for the shell's
// pills and icon rail. Falls back to the item's config `label` when an id isn't
// listed here.
const NAV_LABELS: Record<string, Record<string, string>> = {
  dashboard: { en: "Dashboard", uk: "Головна", pl: "Pulpit", ro: "Panou" },
  supervisor: {
    en: "Supervisor",
    uk: "Супервізор",
    pl: "Superwizor",
    ro: "Supervizor",
  },
  coach: { en: "Coach", uk: "Тренер", pl: "Trener", ro: "Antrenor" },
  drEmery: {
    en: "Dr. Emery",
    uk: "Др. Емері",
    pl: "Dr. Emery",
    ro: "Dr. Emery",
  },
  "ai-coach": {
    en: "AI Coach",
    uk: "AI-тренер",
    pl: "Trener AI",
    ro: "Antrenor AI",
  },
  mentor: { en: "Mentor", uk: "Наставник", pl: "Mentor", ro: "Mentor" },
  clients: {
    en: "Conversations",
    uk: "Розмови",
    pl: "Rozmowy",
    ro: "Conversații",
  },
  notes: { en: "Notes", uk: "Нотатки", pl: "Notatki", ro: "Notițe" },
  files: { en: "Files", uk: "Файли", pl: "Pliki", ro: "Fișiere" },
  courses: { en: "Courses", uk: "Курси", pl: "Kursy", ro: "Cursuri" },
  profile: { en: "Profile", uk: "Профіль", pl: "Profil", ro: "Profil" },
  sessions: { en: "Sessions", uk: "Сеанси", pl: "Sesje", ro: "Sesiuni" },
  schedule: { en: "Schedule", uk: "Розклад", pl: "Harmonogram", ro: "Program" },
  messages: {
    en: "Messages",
    uk: "Повідомлення",
    pl: "Wiadomości",
    ro: "Mesaje",
  },
  personas: {
    en: "Participants",
    uk: "Учасники",
    pl: "Uczestnicy",
    ro: "Participanți",
  },
  scenarios: {
    en: "Scenarios",
    uk: "Сценарії",
    pl: "Scenariusze",
    ro: "Scenarii",
  },
  program: { en: "Program", uk: "Програма", pl: "Program", ro: "Program" },
  "live-practice": {
    en: "Live Practice",
    uk: "Практика",
    pl: "Praktyka",
    ro: "Practică",
  },
  "conversation-maps": { en: "Map", uk: "Карта", pl: "Mapa", ro: "Hartă" },
  learn: { en: "Learn", uk: "Навчання", pl: "Nauka", ro: "Învățare" },
  practice: { en: "Practice", uk: "Практика", pl: "Praktyka", ro: "Practică" },
  progress: { en: "Progress", uk: "Прогрес", pl: "Postęp", ro: "Progres" },
  main: { en: "Main", uk: "Головна", pl: "Główna", ro: "Principal" },
  session: { en: "Session", uk: "Сесія", pl: "Sesja", ro: "Ședință" },
  history: { en: "History", uk: "Історія", pl: "Historia", ro: "Istoric" },
  programs: { en: "Programs", uk: "Програми", pl: "Programy", ro: "Programe" },
  operations: {
    en: "Briefing desk",
    uk: "Брифінг",
    pl: "Odprawa",
    ro: "Briefing",
  },
  cases: { en: "NPPs", uk: "NPP", pl: "NPP", ro: "NPP" },
  debrief: { en: "Debrief", uk: "Розбір", pl: "Omówienie", ro: "Debrief" },
  // The course a member's workspace assigned them — their main thing.
  "assigned-course": {
    en: "My course",
    uk: "Мій курс",
    pl: "Mój kurs",
    ro: "Cursul meu",
  },
};

export function navLabel(id: string, fallback: string, locale: string): string {
  return NAV_LABELS[id]?.[locale] ?? NAV_LABELS[id]?.en ?? fallback;
}

const NAV_GROUP_LABELS: Record<string, Record<string, string>> = {
  work: {
    en: "Your work",
    uk: "Ваша робота",
    pl: "Twoja praca",
    ro: "Munca ta",
  },
};

export function navGroupLabel(id: string, locale: string): string {
  return NAV_GROUP_LABELS[id]?.[locale] ?? NAV_GROUP_LABELS[id]?.en ?? id;
}

// Instructor-only shell entries (the sidebar's instructor group and the mobile
// top bar's jump buttons share these).
export const INSTRUCTOR_LABEL: Record<string, string> = {
  en: "Instructor",
  uk: "Викладач",
  pl: "Instruktor",
  ro: "Instructor",
};
export const STUDIO_LABEL: Record<string, string> = {
  en: "Studio",
  uk: "Студія",
  pl: "Studio",
  ro: "Studio",
};
